import { render, staticRenderFns } from "./PointsPagesContainer.vue?vue&type=template&id=1ce1f808"
import script from "./PointsPagesContainer.vue?vue&type=script&lang=js"
export * from "./PointsPagesContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports